import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loader = ({ showText, text }) => {
    return (
        <div
            className="d-flex justify-content-center align-items-center"
            style={{
                width: '100%',
                height: '100%',
                minHeight: '200px', // optional fallback
            }}
        >
            <div className="text-center">
                <Spinner animation="border" role="status" />
                {showText && <p className="mt-2">{text || 'Loading...'}</p>}
            </div>
        </div>
    );
};

export default Loader;